/** @format */

import { reducerDebug } from '../../core/debug';

export const numberRangeConstants = {
    NUMBER_RANGE_LIST: 'numbe_range_list',
    NUMBER_RANGE_ADD: 'number_range_add',
    NUMBER_RANGE_EDIT: 'number_range_edit',
};

export type numberRangeReducerType = {
    type: string;
    collections?: any;
    success: boolean;
    data: any;
};

export function numberRangeReducers(state = {}, action: numberRangeReducerType): object {
    reducerDebug('Number range reducer: ' + action.type);
    switch (action.type) {
        case numberRangeConstants.NUMBER_RANGE_LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case numberRangeConstants.NUMBER_RANGE_EDIT:
        case numberRangeConstants.NUMBER_RANGE_ADD:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        default:
            return {
                ...state,
                success: false,
                deletedSuccess: false,
            };
    }
}
